module.exports = __webpack_public_path__ + "img/1_023.fef92c58.jpg";